import styled from 'styled-components';
import { Box, Paper, Button, Typography } from '@mui/material';

export const ForgotPasswordContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 24px;
`;

export const StyledForgotPaper = styled(Paper)`
  padding: 48px;
  width: 100%;
  max-width: 500px;
  border-radius: 24px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04) !important;
`;

export const FormWrapper = styled.div`
  margin-top: 32px;
`;

export const InputSpacing = styled(Box)`
  margin-bottom: 24px;
`;

export const MessageBanner = styled(Typography)<{ $isSuccess: boolean }>`
  margin-bottom: 24px;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-size: 0.875rem;
  background-color: ${(props) => (props.$isSuccess ? '#edf7ed' : '#fdeded')};
  color: ${(props) => (props.$isSuccess ? '#1e4620' : '#5f2120')};
`;

export const StyledSubmitButton = styled(Button)`
  padding: 14px 0 !important;
  text-transform: none !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  box-shadow: none !important;
  background-color: #0061ff !important;

  &:hover {
    background-color: #0052db !important;
    box-shadow: none !important;
  }

  &:disabled {
    background-color: #e0e0e0 !important;
  }
`;
